var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47233 5.94728L8.919 5.94728L5.66566 9.20062C5.40566 9.46062 5.40566 9.88728 5.66566 10.1473C5.92566 10.4073 6.34566 10.4073 6.60566 10.1473L10.999 5.75395C11.259 5.49395 11.259 5.07395 10.999 4.81395L6.60566 0.420617C6.34566 0.160618 5.92566 0.160618 5.66566 0.420617C5.54083 0.545172 5.47067 0.714272 5.47067 0.890617C5.47067 1.06696 5.54083 1.23606 5.66566 1.36062L8.919 4.61395L1.47233 4.61395C1.10566 4.61395 0.805664 4.91395 0.805664 5.28062C0.805664 5.64728 1.10566 5.94728 1.47233 5.94728Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.120ae323.svg";
export { ForwardRef as ReactComponent };